import RentFree from "../../../../src/events/2022/02/rent-free/main";
import * as React from 'react';
export default {
  RentFree,
  React
};